/**
 * Detecta o erro do Next.js quando o browser chama uma Server Action com ID
 * de um build antigo (aba aberta após deploy, ou chave de criptografia diferente
 * entre instâncias).
 *
 * @see https://nextjs.org/docs/messages/failed-to-find-server-action
 */
export function isUnrecognizedServerActionError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false
  }

  if (error.name === 'UnrecognizedActionError') {
    return true
  }

  return /Server Action ["'].+["'] was not found on the server/i.test(
    error.message
  )
}
